/** @format */

const userAgent = navigator.userAgent || "";

export function isIOS() {
  return (
    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) ||
    (["iPad", "MacIntel"].includes(window.navigator.platform) &&
      "ontouchstart" in window)
  );
}
export function isIOSSafari() {
  return isIOS() && isWebKit() && !userAgent.match(/CriOS/i);
}

export function isIOS11() {
  return isIOS() && !!userAgent.match(/Mobile\/15A372/i);
}

export function isLongMobile() {
  return window.screen.availHeight >= 768;
}

export function isIOS15SafariAndLater() {
  const iOSVersion = userAgent.match(/OS (\d+)/);
  return isIOSSafari() && iOSVersion && iOSVersion[1] >= 15;
}

export function isWebKit() {
  return !!userAgent.match(/WebKit/i);
}

export function isAndroid() {
  return userAgent.indexOf("Android") > 0;
}

export function isDesktop() {
  return window.screen.availWidth >= 1024 && !(isAndroid() || isIOS());
}
export function isMobile() {
  return isAndroid() || isIOS() || window.screen.availWidth <= 768;
}

export function isTabletOrBigger() {
  return window.innerWidth > 767;
}

export function getDeviceType() {
  if (isIOS()) {
    return "ios";
  } else if (isAndroid()) {
    return "android";
  } else if (isDesktop()) {
    return "desktop";
  }
}



// WEBPACK FOOTER //
// ./src/utils/device.js